import { ReportingFieldRelationship } from '@flexible-reports/store/api/metadata/api-types';
import { ComplimentaryFieldMap, InCompatibleField } from '@flexible-reports/store/metadata.types';
import { computeTransitiveFields } from '@flexible-reports/store/api/metadata/transformers/compute-transitive-fields';

export interface FieldRelationships {
  inCompatibleFields: InCompatibleField[];
  requiredFields: { id: string; fields: string[] }[];
  complimentaryFieldsMap: ComplimentaryFieldMap;
}

export const transformRelationshipsFromApiResponse = (relationships: ReportingFieldRelationship[]): FieldRelationships => {
  const inCompatibleFields: InCompatibleField[] = [];
  const baseRequiredFields: Map<string, string[]> = new Map<string, string[]>();
  const complimentaryFieldsMap: ComplimentaryFieldMap = {};

  relationships.forEach(relationship => {
    const { reportingFieldId, incompatibleReportingFieldIds, requiredReportingFieldIds, complementaryReportingFieldIds } = relationship;

    if (incompatibleReportingFieldIds.length > 0) {
      inCompatibleFields.push({
        id: reportingFieldId,
        incompatibleWith: incompatibleReportingFieldIds
      });
    }

    if (requiredReportingFieldIds.length > 0) {
      baseRequiredFields.set(reportingFieldId, requiredReportingFieldIds);
    }

    complimentaryFieldsMap[reportingFieldId] = {
      complimentaryFields: complementaryReportingFieldIds,
      classifications: null
    };
  });

  const transitiveRequiredFields = Array.from(computeTransitiveFields(baseRequiredFields).entries()).map(([id, fields]) => ({
    id,
    fields
  }));

  return {
    inCompatibleFields,
    requiredFields: transitiveRequiredFields,
    complimentaryFieldsMap
  };
};
